import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/download_production/69c876e1c3f848001379d3d0/citytprm/src/app/due-diligence-workspace/components/DDWorkspace.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/download_production/69c876e1c3f848001379d3d0/citytprm/src/components/AppLayout.tsx");
